import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Modal,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../Components/LoadingScreen";
import EllipsisText from "react-ellipsis-text";
import { Editor } from "@tinymce/tinymce-react";
import axios2 from "axios";
import ProgressBar from "../../Components/ProgressBar";

const AddEditFile = (props) => {
  const navigate = useNavigate();
  const { id, lectureId, fileId } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false
  );
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [progressNumber, setProgressNumber] = useState(0);
  const [imagePreview, setImagePreview] = useState("");
  const [item, setItem] = useState({
    roleAr: "",
    roleEn: "",
    nameAr: "",
    nameEn: "",
    descriptionEn: "",
    descriptionAr: "",
    isActive: true,
     isDownloadable: false,
  });
  const handleChangeNameEn = (newValue) => {
    setItem({ ...item, nameEn: newValue });
    setNameEnError("");
  };
  const [nameEnError, setNameEnError] = useState("");

  const handleChangeNameAr = (newValue) => {
    setItem({ ...item, nameAr: newValue });
    setNameArError("");
  };
  const [nameArError, setNameArError] = useState("");
  const handleChangeActive = (newValue) => {
    setItem({ ...item, isActive: newValue });
  };
  const handleChangeDownloadable = (newValue) => {
    setItem({ ...item, isDownloadable: newValue });
};
  const [files, setFiles] = useState([]);

  const handleDropZone = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFiles((files) => [...files, ...acceptedFiles]),
    []
  );

  const validImageTypes = ["image/gif", "image/jpeg", "image/png"];

  const fileUpload = !files.length && (
    <DropZone.FileUpload
      actionHint={"Accepts pngs, jpegs, docx, pdfs, ppts and xlsx"}
    />
  );
  const uploadedFiles = files.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(files[files.length - 1].type)
              ? window.URL.createObjectURL(files[files.length - 1])
              : NoteIcon
          }
        />
        <div>
          {files[files.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {files[files.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const [imageError, setImageError] = useState("");
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;

  const imageKey = useRef("");
  const sendImage = (files) => {
    // setItem({
    //   ...item,
    //   image:
    //     validImageTypes.indexOf(files[files.length - 1].type) > 0
    //       ? window.URL.createObjectURL(files[files.length - 1])
    //       : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
    // });
    // setImageError("");
    setIsFileUploading(true);
    let url2 = "";
    const form_data = new FormData();
    form_data.append("file_name", files[files.length - 1].name);
    form_data.append("content_type", files[files.length - 1].type);
    axios
      .post("/generate-presigned-url", form_data)
      .then((res) => {
        imageKey.current = res.data.key;
        url2 = res.data.url;

        axios2
          .put(url2, files[files.length - 1], {
            headers: {
              "Content-Type": files[files.length - 1].type,
            },
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setProgressNumber(`${percentCompleted}`);
            },
          })
          .then((res) => {
            setIsFileUploading(false);
            setItem({
              ...item,
              image:
                validImageTypes.indexOf(files[files.length - 1].type) > 0
                  ? window.URL.createObjectURL(files[files.length - 1])
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            });
            setImageError("");
          })
          .catch((error) => {
            if (error.response) {
              console.error("Status:", error.response.status);
              console.error(
                "Headers:",
                JSON.stringify(error.response.headers, null, 2)
              );
              console.error("Data:", error.response.data);
            } else {
              console.error("Error Message:", error.message);
            }
          });
      })
      .catch((err) => console.log(""));

    // axios
    //   .post("/generate-presigned-url", form_data)
    //   .then((res) => {
    //     console.log("resss==", res.data.key);
    //     setIsImageUploading(false);
    //     setItem({
    //       ...item,
    //       image:
    //         validImageTypes.indexOf(files[files.length - 1].type) > 0
    //           ? window.URL.createObjectURL(files[files.length - 1])
    //           : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
    //     });
    //     imageKey.current = res.data.key;
    //     setImageError("");
    //   })
    //   .catch((err) => console.log(err));
  };
  useEffect(() => {
    props.type === "edit" &&
      axios
        .get(`/files/${fileId}`)
        .then((result) => {
          console.log(result.data.data);
          setItem({
            nameEn:
              result?.data?.data?.name && result?.data?.data?.name?.en
                ? result.data.data.name.en
                : "",
            nameAr:
              result?.data?.data?.name && result?.data?.data?.name?.ar
                ? result.data.data.name.ar
                : "",
            image: result?.data?.data?.url
              ? "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
              : "",
            isActive: result?.data?.data?.is_active ? true : false,
             isDownloadable: !!result?.data?.data?.is_downloadable, 
             
          });
          setIsSaving(false);
        })

        .catch((err) => console.log(err));
  }, []);
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} File`}
      backAction={{
        onAction: () =>
          navigate(`/admin/courses/${id}/lectures/${lectureId}/files`),
      }}
      narrowWidth
    >
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <FormLayout>
          <FormLayout.Group>
            <TextField
              value={item.nameEn}
              onChange={handleChangeNameEn}
              label="Name En"
              requiredIndicator
              error={nameEnError}
            />
            <TextField
              value={item.nameAr}
              onChange={handleChangeNameAr}
              label="Name Ar"
              align="right"
              requiredIndicator
              error={nameArError}
            />
          </FormLayout.Group>

          <Text>
            File <span style={{ color: "#8e1f0b" }}>*</span>
          </Text>

          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Thumbnail size="large" source={item.image ? item.image : ""} />
            </div>
            <div
              style={{
                width: "100%",
                marginLeft: "10px",
              }}
            >
              <DropZone
                accept=".jpeg,.png,.docx,.doc,.pdf,.ppt,.pptx,.xls,.xlsx "
                onDrop={handleDropZone}
                allowMultiple={false}
                onDropAccepted={sendImage}
              >
                {uploadedFiles}
                {fileUpload}
              </DropZone>
            </div>
          </div>
          <InlineError message={imageError} />

          <Checkbox
            label="Is active"
            checked={item.isActive}
            onChange={handleChangeActive}
          />
          <Checkbox
    label="Is downloadable"
    checked={item.isDownloadable}
    onChange={handleChangeDownloadable}
    helpText="If unchecked, users can only view the file, not download it"
/>
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              loading={isSaving}
              tone="critical"
              onClick={() => {
                setIsSaving(true);
                axios
                  .delete(`/files/${fileId}`)
                  .then((result) => {
                    navigate(
                      `/admin/courses/${id}/lectures/${lectureId}/files`
                    );
                  })
                  .catch((err) => console.log(err));
              }}
            >
              Delete
            </Button>
          )
        }
      />
      {toastMarkup}
      {isFileUploading ? <ProgressBar progress={progressNumber} /> : null}
    </Page>
  );

  function handleSave() {
    if (
      !item.nameEn ||
      !item.nameAr ||
      (props?.type === "add" && !imageKey.current)
    ) {
      !item.nameEn && setNameEnError("This field is required");
      !item.nameAr && setNameArError("This field is required");
      props?.type === "add" &&
        !imageKey.current &&
        setImageError("Please upload a file");
    } else {
      setIsSaving(true);
      console.log("type=", files[0]);
      const form_data = new FormData();
      item.nameEn && form_data.append("name[en]", item.nameEn);
      item.nameAr && form_data.append("name[ar]", item.nameAr);
      imageKey.current && form_data.append("url", imageKey.current);
      imageKey.current &&
        form_data.append("type", files[0].name.split(".").pop());
      form_data.append("is_active", item.isActive ? 1 : 0);
       form_data.append("is_downloadable", item.isDownloadable ? 1 : 0); 
      form_data.append("lecture_id", lectureId);
      props?.type === "edit" && form_data.append("_method", "PATCH");
      props.type === "add"
        ? axios
            .post(`/files`, form_data)
            .then((result) => {
              navigate(`/admin/courses/${id}/lectures/${lectureId}/files`);
            })
            .catch((err) => console.log(err))
        : axios
            .post(`/files/${fileId}`, form_data)
            .then((result) => {
              //toggleActive();
              navigate(`/admin/courses/${id}/lectures/${lectureId}/files`);
            })
            .catch((err) => console.log(err));
    }
  }
};

export default AddEditFile;
